module.exports = "<div class=\"table-grid__checkbox-wrapper\" uib-tooltip= \"{{vm.toolTip}}\">\n    <input id=\"{{vm.checklistValue}}\" type=\"checkbox\"\n    class=\"table-grid__checkbox\"\n    ng-model=\"vm.isChecked\"\n    checklist-model=\"vm.metaData[vm.options.dataSet].selectedValues\"\n    checklist-value='vm.checklistValue'\n    ng-change='vm.toggleCheckbox()'\n    ng-disabled='vm.isDisabled'>\n    <label for=\"{{::vm.checklistValue}}\"></label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/tableGridCheckboxCell/tableGridCheckboxCell.html
// module id = 332
// module chunks = 1